// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1rrsu","inputDescription":"styles_inputDescription__2Wm9z"};